export default "__VITE_ASSET__Bk3UT7rf__"